<div class="container">
  <mat-card>
    <div class="layout-row responsive-column gap-20px">
      <div class="flex-50">
        <mat-nav-list>
          <mat-list-item [routerLink]="['tax-components']" *LOSxHasPermission="'READ_TAXCOMPONENT'">
            <mat-icon matListIcon [routerLink]="['tax-components']">
              <fa-icon icon="building" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine [routerLink]="['tax-components']">{{ 'labels.heading.Manage Tax Components' | translate }}</h4>
            @if (!arrowBooleans[0]) {
              <fa-icon (click)="arrowBooleansToggle(0); $event.stopPropagation()" icon="arrow-down" size="md"></fa-icon>
            }
            @if (arrowBooleans[0]) {
              <fa-icon (click)="arrowBooleansToggle(0); $event.stopPropagation()" icon="arrow-up" size="md"></fa-icon>
            }
            @if (arrowBooleans[0]) {
              <p matLine [routerLink]="['tax-components']">
                {{ 'labels.heading.Define Tax Components' | translate }}
              </p>
            }
          </mat-list-item>
        </mat-nav-list>
      </div>

      <div class="flex-50">
        <mat-nav-list>
          <mat-list-item [routerLink]="['tax-groups']" *LOSxHasPermission="'READ_TAXGROUP'">
            <mat-icon matListIcon [routerLink]="['tax-groups']">
              <fa-icon icon="building" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine [routerLink]="['tax-groups']">{{ 'labels.heading.Manage Tax Groups' | translate }}</h4>
            @if (!arrowBooleans[1]) {
              <fa-icon (click)="arrowBooleansToggle(1); $event.stopPropagation()" icon="arrow-down" size="md"></fa-icon>
            }
            @if (arrowBooleans[1]) {
              <fa-icon (click)="arrowBooleansToggle(1); $event.stopPropagation()" icon="arrow-up" size="md"></fa-icon>
            }
            @if (arrowBooleans[1]) {
              <p matLine [routerLink]="['tax-groups']">
                {{ 'labels.heading.Define Tax Groups' | translate }}
              </p>
            }
          </mat-list-item>
        </mat-nav-list>
      </div>
    </div>
  </mat-card>
</div>
